export const holdplaceTranslationId = type => {
    const typeToUpperCase = type?.toUpperCase();

    if (typeToUpperCase === "TOPICS" || typeToUpperCase === "SPEAKERS" || typeToUpperCase === "VIDEOS")
        return `MODAL.${typeToUpperCase}_SELECTOR.SEARCHBAR.PLACEHOLDER`;
    return "MODAL.ITEM_SELECTOR.SEARCHBAR.PLACEHOLDER";
};

export const handleSearchInput = ({e, allItems, setFilteredItems}) => {
    const lowerCaseValue = e?.target?.value?.toLowerCase();

    if (!lowerCaseValue) setFilteredItems(null);
    else {
        const filteredByName = allItems?.filter(item => {
            const itemName = item.name || item.title || "";
            return itemName.toLowerCase().includes(lowerCaseValue);
        });

        setFilteredItems(filteredByName);
    }
};
